import moment from "moment";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import { HiMiniChartBar } from "react-icons/hi2";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect, useCallback } from "react";

import Pagination from "../../components/Pagination";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import Placeholder from "../../components/Placeholder/PlaceholderText";
import { getCountries, getAffiliateAll } from "../../store/middleware";
import { setAffiliateManagement } from "../../store/slices/affiliate.slice";
import affiliateIcon from "../../assets/images/icons/icon_affiliate_header.svg";

import { FilterUser, TableUser } from "./styles";

function ManageAffiliate() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { affiliateManagement } = useSelector((state) => state.affiliateReducer);

  const [countries, setCountries] = useState([]);
  const [expanded, seTexpanded] = useState(false);
  const [filter, setFilter] = useState({
    name: "",
    login: "",
    slug: "",
    type: "",
    active: 0,
    pageSize: 20,
    countryId: 0,
    pageNumber: 1,
    privileges: "",
    subscriptionDate: "",
  });

  const applyFilters = async () => await dispatch(getAffiliateAll(filter));

  const handlePagination = useCallback(async (page) => {
    setFilter((state) => ({ ...state, ["pageNumber"]: Number(page) }));
    await dispatch(getAffiliateAll({ ...filter, ["pageNumber"]: Number(page) }));
    // eslint-disable-next-line
  }, []);

  const getData = async () => {
    dispatch(setAffiliateManagement({}));
    dispatch(getCountries()).then((res) => setCountries(res));
    applyFilters();
  };

  const clearFilters = () => {
    const newFilters = {
      name: "",
      login: "",
      slug: "",
      type: "",
      active: 0,
      pageSize: 20,
      countryId: 0,
      pageNumber: 1,
      privileges: "",
      subscriptionDate: "",
    };

    setFilter(newFilters);
    dispatch(getAffiliateAll(newFilters));
  };

  const handleShowMore = (e) => {
    e.preventDefault();
    seTexpanded((state) => !state);
  };

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    let newValue = type === "checkbox" ? checked : value;

    setFilter((state) => ({ ...state, [name]: newValue }));
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />
      <section>
        <Header title="Affiliates" icon={<img src={affiliateIcon} alt="AffiliateIcon" />} typeIcon="custom" />

        <div className="content">
          <FilterUser>
            <div className="filterContent">
              <h2>
                <i className="fa fa-filter" aria-hidden="true"></i>
                {t("FILTERS")}
              </h2>

              <form className="formulario">
                <div className="lineInput">
                  <label htmlFor="name">{t("NAME")}</label>
                  <input placeholder="User name" name="name" onChange={handleChange} value={filter.name} />
                </div>

                <div className="lineInput">
                  <label htmlFor="login">{t("EMAIL")}</label>
                  <input placeholder="Email" name="login" onChange={handleChange} value={filter.login} />
                </div>

                <div className="lineInput">
                  <label htmlFor="slug">Slug</label>
                  <input placeholder="Slug" name="slug" onChange={handleChange} value={filter.slug} />
                </div>

                <div className="lineInput">
                  <label htmlFor="status">{t("STATUS")}</label>
                  <select name="active" value={filter.active} onChange={handleChange}>
                    <option value={""}>{t("SELECT")}</option>
                    <option value="true">{t("ACTIVE")}</option>
                    <option value="false">{t("INACTIVE")}</option>
                  </select>
                </div>
              </form>

              {expanded && (
                <div>
                  <hr style={{ width: "100%", margin: "0" }} />
                  <br />
                  <form className="formulario">
                    <div className="lineInput">
                      <label htmlFor="countryId">{t("COUNTRY")}</label>
                      <select name="countryId" value={filter.countryId} onChange={handleChange}>
                        <option value={0}>{t("SELECT")}</option>
                        {countries?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="lineInput">
                      <label htmlFor="subscriptionDate">{t("SUBSCRIPTION_DATE")}</label>
                      <input
                        type="date"
                        min="2000-01-01"
                        max="2050-12-31"
                        id="subscriptionDate"
                        name="subscriptionDate"
                        onChange={handleChange}
                        value={filter.subscriptionDate}
                      />
                    </div>

                    <div className="lineInput">
                      <label htmlFor="paymentProblems">{t("TYPE")}</label>
                      <select name="type" value={filter.type} onChange={handleChange}>
                        <option value="">{t("SELECT")}</option>
                        <option value="student">{t("STUDENT")}</option>
                        <option value="teacher">{t("TEACHER")}</option>
                        <option value="affiliate">{t("AFFILIATE")}</option>
                      </select>
                    </div>

                    <div className="lineInput">
                      <label htmlFor="levelId">{t("PRIVILEGES")}</label>
                      <select name="privileges" value={filter.privileges} onChange={handleChange}>
                        <option value="">{t("SELECT")}</option>
                        <option value="blue">{t("BLUE")}</option>
                        <option value="bronze">{t("BRONZE")}</option>
                        <option value="silver">{t("SILVER")}</option>
                        <option value="gold">{t("GOLD")}</option>
                        <option value="platinum">{t("PLATINUM")}</option>
                      </select>
                    </div>
                  </form>
                </div>
              )}

              <div className="boxButton">
                <div className="buttons">
                  <button onClick={handleShowMore}>Show more +</button>
                  <button onClick={clearFilters}>{t("CLEAR_FILTERS")}</button>
                  <button onClick={applyFilters}>{t("FILTER")}</button>
                </div>
              </div>
            </div>
          </FilterUser>

          {/* <InfoUser>
            <div className="wrapperTitle">
              <HiMiniChartBar color={"#87868F"} size={16} />

              <p>Idicators by Privilege</p>
            </div>

            <div className="wrapperResult">
              <div>
                <p>{t("Total")}</p>
                <p className="fullBorder">344</p>
              </div>
              <div>
                <p>{t("BLUE")}</p>
                <p className="fullBorder">80</p>
              </div>
              <div>
                <p>{t("BRONZE")}</p>
                <p className="fullBorder">80</p>
              </div>
              <div>
                <p>{t("GOLD")}</p>
                <p className="fullBorder">84</p>
              </div>
              <div>
                <p>{t("SILVER")}</p>
                <p className="fullBorder">54</p>
              </div>
              <div>
                <p>{t("PLATINUM")}</p>
                <p className="fullBorder"> 50</p>
              </div>
            </div>
          </InfoUser> */}

          <div>
            {affiliateManagement?.items?.length > 0 ? (
              <TableUser>
                <div className="bigBox bigBoxTableStudent">
                  <table>
                    <thead>
                      <tr>
                        <th style={{ width: 60 }}>Slug</th>
                        <th>{t("NAME")}</th>
                        <th>{t("EMAIL")}</th>
                        <th>{t("SUBSCRIPTION_DATE")}</th>
                        <th>{t("TYPE")}</th>
                        {/* <th>{t("PRIVILEGES")}</th> */}
                        <th>{t("STATUS")}</th>
                        <th style={{ textAlign: "center" }}>{t("OPTIONS")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {affiliateManagement?.items?.map((item) => (
                        <tr key={item.userId}>
                          <td>{item.slug?.slice(0, 8)}</td>
                          <td>{decryptIfEncrypted(item.user.name)}</td>
                          <td>{decryptIfEncrypted(item.user.email)}</td>
                          <td>{moment(item.user.createdAt).format("YYYY-MM-DD")}</td>
                          <td>{item.user.role}</td>
                          {/* <td>Bronze</td> */}
                          <td>
                            <span className={!item.active ? "inativo" : "activo"}>
                              {item.active ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td>
                            <Link to={{ pathname: "/manage-affiliate/" + item.userId }}>
                              <button>
                                View <i className="fa fa-angle-right" aria-hidden="true"></i>
                              </button>
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <Pagination
                  pageCurrent={affiliateManagement.pageNumber}
                  totalPages={affiliateManagement.totalPages}
                  totalFound={affiliateManagement.pageSize}
                  totalResults={affiliateManagement?.totalFound ?? 20}
                  onClick={(page, type) => handlePagination(page, type)}
                />
              </TableUser>
            ) : (
              <Placeholder label="No results" />
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default ManageAffiliate;
